import { render, staticRenderFns } from "./WDGInput.vue?vue&type=template&id=5967f66a&"
import script from "./WDGInput.vue?vue&type=script&lang=js&"
export * from "./WDGInput.vue?vue&type=script&lang=js&"
import style0 from "./WDGInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../prospect-setup/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports